/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 14,
    height: 9,
    viewBox: '0 0 14 9',
    data: '<path pid="0" _fill="#161616" d="M.001 1.747L1.684 0l5.349 5.56L12.332.054l1.667 1.728-6.893 7.166-.04-.042-.09.093z"/>'
  }
})
